'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialFlickrCircular = function TiSocialFlickrCircular(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 35c-4.1 0-7.7-1.5-10.6-4.4-2.9-2.9-4.4-6.5-4.4-10.6 0-4.1 1.5-7.7 4.4-10.6 2.9-2.9 6.5-4.4 10.6-4.4 4.1 0 7.7 1.5 10.6 4.4 2.9 2.9 4.4 6.5 4.4 10.6 0 4.1-1.5 7.7-4.4 10.6-2.9 2.9-6.5 4.4-10.6 4.4z m0-26.7c-3.3 0-6 1.1-8.3 3.4-2.3 2.3-3.4 5-3.4 8.3 0 3.2 1.1 5.9 3.4 8.2 2.3 2.3 5 3.5 8.3 3.5 3.2 0 5.9-1.2 8.2-3.5 2.3-2.3 3.5-5 3.5-8.2 0-3.3-1.2-6-3.5-8.3-2.3-2.3-5-3.4-8.2-3.4z m-5 15.9c-2.3 0-4.2-1.9-4.2-4.2s1.9-4.2 4.2-4.2 4.2 1.9 4.2 4.2-1.9 4.2-4.2 4.2z m0-6.7c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5z m10 6.7c-2.3 0-4.2-1.9-4.2-4.2s1.9-4.2 4.2-4.2 4.2 1.9 4.2 4.2-1.9 4.2-4.2 4.2z' })
        )
    );
};

exports.default = TiSocialFlickrCircular;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-flickr-circular.js
// module id = 3949
// module chunks = 0